module.exports = __webpack_public_path__ + "assets/certificate_pdf/Adobe InDesign CC_Silicon Stone Education_20210803.85e95ab2.pdf";